import type { CloudType, ProductType } from '../../types'
import type { SetSelectedAccountPayload } from '../../types/accountSelection'
import { AccountSelectionActionTypes } from './actionTypes'

export const setSelectedAccount = (
  accountId: string,
  product: ProductType,
  cloud: CloudType
): { type: string; payload: SetSelectedAccountPayload } => ({
  type: AccountSelectionActionTypes.SET_SELECTED_ACCOUNT,
  payload: { accountId, product, cloud },
})
